import { get, post, postReturnResponse, remove } from "../api_helper";
import * as url from "../url_helper";

const URL_AdvanceSearch = "/AdvanceSearch/[LOCATION]";
const Benefits_URL_AdvanceSearch = "/BenefitAdvanceSearch/[LOCATION]";
const Job_URL_AdvanceSearch = "/JobApplicantAdvanceSearch/[LOCATION]";

const GG1_EXCEL_ADVANCESEARCH = "/AdvanceSearch";
const BENEFITS_EXPORT_URL = "/BenefitAdvanceSearch";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;
//Post
export const gg1ReportDownload = (payload) => {
  const { fileExtension, headername, footerContent, headerContent, ...rest } =
    payload;
  if (headername) {
    // rest['headername'] = headername?.replace(/\s+/g, ' ')
  }
  if (footerContent) {
    rest["footerContent"] = footerContent?.replace(/\s+/g, " ");
  }
  if (headerContent) {
    rest["headerContent"] = headerContent?.replace(/\s+/g, " ");
  }

  const shouldUsePMISExport = [
    "EligListsByAnnouncement",
    "All_eligibilitylist",
    "applicant-by-annountment-eligiblity",
    "GettDetails",
  ].includes(payload?.tableName);

  const exportBasePath =
    payload.location == "Benefits-global"
      ? BENEFITS_EXPORT_URL
      : payload?.location === "JobApplicant-global" ||
          payload?.tableName === "vw_Job_Applications_of_Announcement"
        ? "/JobApplicantAdvanceSearch"
        : shouldUsePMISExport
          ? "/PMISAdvanceSearch"
          : GG1_EXCEL_ADVANCESEARCH;

  return postReturnResponse(
    baseURL +
    exportBasePath +
    `/${payload.isOJA ? "OJAExport" : "CommonSearchExport"
    }?fileExtension=${fileExtension}${headername ? `&headername=${typeof headername === 'string' ? headername : 'headername'}` : ""
    }`,
    rest,
    { responseType: "blob" }
  );
};

export const advanceSearch = (payload, applicationName) => {
  if (payload.location === "npa") {
    return post(
      baseURL +
      URL_AdvanceSearch.replace("[LOCATION]", payload.location) +
      `?pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}&transType=NPA`,
      payload
    );
  } else if (applicationName === "Benefits") {
    return post(
      baseURL +
      Benefits_URL_AdvanceSearch.replace("[LOCATION]", payload.location) +
      `?pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}`,
      payload
    );
  } else if (applicationName === "JobApplication") {
    return post(
      baseURL +
      Job_URL_AdvanceSearch.replace("[LOCATION]", payload.location) +
      `?pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}`,
      payload
    );
  } else {
    let customHeaders = {};
    if (
      [
        "fn_GetLeaveApplications",
        "fn_OutsideEmployment",
        "fn_Receipent",
      ].includes(payload?.tableName)
    ) {
      customHeaders = {
        headers: {
          role: sessionStorage?.getItem("currentRole"),
        },
      };
    }
    const isJobNotificationTable = [
      "fn_Notification_Audittrail",
      "fn_Notification_by_GENERAL_AVAILIBILITY_IDnAppicationID",
      "fn_Notification_by_CERTIFICATION_PIDnAppicationID",
      "fn_Notification_Chat",
      "fn_Notification_DocumentReminder_count",
    ].includes(payload.tableName);

    const requestUrl = isJobNotificationTable
      ? baseURL + Job_URL_AdvanceSearch.replace("[LOCATION]", payload.location)
      : baseURL +
      URL_AdvanceSearch.replace("[LOCATION]", payload.location).replace(
        "AdvanceSearch",
        [
          "GetEligibilityAndCertList",
          "announcement",
          "EligListsByAnnouncement",
          "EligibilitySummaryByAnnouncementID",
          "applicant-by-annountment-eligiblity",
          "general-availibility-list",
          "Eligibility-Summary",
          "Eligibility-Announcement-Id-Summary",
          "GENERAL-AVAIL",
          "CERT-LIST",
          "GET-ASSIGN-CERT-LIST",
          "CERT-APP",
          "GET-CERTIFICATION-APP",
          "GeneralAvailability-By-Announcement",
          "GET-CERTIFICATION",
          "GET-CERTIFICATION-N-GA-AUDIT-TRAIL",
          "RULES",
          "CHECK-ASSIGN-CERT",
          "Sankeyapplicant",
          "GettDetails",
          "CERT_STATUS",
          "All_eligibilitylist",
          "Get-hrcontrols",
          "announcement-status-tracker"
        ].includes(payload.tableName)
          ? "PMISAdvanceSearch"
          : "AdvanceSearch"
      );

    return post(
      requestUrl + `?pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}`,
      payload,
      customHeaders
    );
  }
};

export const loadColumns = (tableName, applicationName) => {
  if (applicationName == "Benefits") {
    return get(
      baseURL + url.BENEFITS_ADVANCE_SEARCH_LOAD_COLUMNS + "=" + tableName
    );
  } else if (applicationName === "JobApplication") {
    return get(
      baseURL + url.JOBAPPLICATION_ADVANCE_SEARCH_LOAD_COLUMNS + "=" + tableName
    );
  } else {
    return get(baseURL + url.ADVANCE_SEARCH_LOAD_COLUMNS + "=" + tableName);
  }
};

export const findAsyouType = (table, keyField, valueField, search) =>
  get(
    url.ADVANCE_SEARCH_LOAD_FINDASTYPE +
    "/" +
    `${table}/${keyField}/${valueField}/${search ? search : ""}`
  );

export const saveAdvanceSearch = async (payload, applicationName) => {
  // if (applicationName == "Benefits") {
  return await post(
    baseURL + URL_AdvanceSearch.replace("[LOCATION]", payload.location),
    payload
  );
  // }
};

export const deleteSavedQuery = (payload) => {
  console.log("payload", payload);
  return remove(
    baseURL + URL_AdvanceSearch.replace("[LOCATION]", "DeleteSearch"),
    payload
    //   `/${Number(qID)}`
    // payload
  );
};

export const getAdvanceSearchById = (payload, params) =>
  get(
    baseURL + URL_AdvanceSearch.replace("[LOCATION]", payload.location),
    params
  );
export const getAllAdvanceSearchDAta = (payload) =>
  post(
    baseURL + URL_AdvanceSearch.replace("[LOCATION]", payload.location),
    payload
  );

export const findByAdavanceSearch = async (payload) => {
  const { table, key, value, order } = payload;
  return await get(
    baseURL +
    url.ADVANCE_SEARCH_LOAD_FINDASTYPE +
    `/${table}/${key}/${value}?order=${order}`
  );
};

export const advanceSearchDashboard = (payload, tableName) => {
  if (payload.location === "npa") {
    return post(
      baseURL +
      URL_AdvanceSearch.replace("[LOCATION]", payload.location) +
      `/${tableName}`,
      payload
    );
  } else {
    return post(
      `${process.env.REACT_APP_API_DOTNET_URL + "/AdvanceSearch/global"}`,
      payload
    );
  }
};
